<template>
    <multiselect
        class="custom-multiselect"
        v-model="value"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :placeholder="text"
        label="label"
        track-by="value"
        :preselect-first="false"
        @select="onSelect"
        @remove="onSelect"
        :showLabels="false"
        selectedLabel="Wybrano"
    >
        <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
            >
                Wybrano: {{ values.length }}</span
            > </template
        ><span slot="noResult">Nie znaleziono wyników</span>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    data() {
        return {
            value: []
        }
    },
    props: {
        text: {
            type: String,
            required: false
        },
        options: {
            type: Array,
            required: true
        },
        selectedOption: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onSelect() {
            setTimeout(() => {
                this.$emit(
                    'onChange',
                    this.value.map(el => el.value)
                )
            }, 0)
        }
    },
    created() {
        this.value = this.selectedOption
    },
    components: {
        Multiselect
    },
    watch: {
        selectedOption() {
            if (this.selectedOption.length === 0) {
                this.value = []
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
